import { useState } from 'react';

const useCustomHook = () => {
  const [values, setValues] = useState({
    password: '',
    confirm: '',
  });

  return {
    values,
    setValues,
  };
};

export default useCustomHook;
